import { render, staticRenderFns } from "./TypographyDemo.vue?vue&type=template&id=4bb17e8e&scoped=true&"
import script from "./TypographyDemo.vue?vue&type=script&lang=js&"
export * from "./TypographyDemo.vue?vue&type=script&lang=js&"
import style0 from "./TypographyDemo.vue?vue&type=style&index=0&id=4bb17e8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb17e8e",
  null
  
)

export default component.exports